import { HttpClient, HttpErrorResponse,HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, tap, throwError, Observable } from "rxjs";
import { User } from "../Models/User.model";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  
  private tokenKey = 'access_token';
  private userKey = 'current_user'; 
  isLoggedIn: boolean = false;

  public currentUserSubject: BehaviorSubject<User | null>;
  public currentUser$: Observable<User | null>;
  private isLoadingSubject: BehaviorSubject<boolean>;
  public isLoading$: Observable<boolean>;

  get currentUserValue(): User | null {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: User | null) {
    this.currentUserSubject.next(user);
  }

  constructor(private router: Router, private http: HttpClient) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<User | null>(this.getUser());
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
  }
  
  IsLoggedIn(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  } 

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/login`, { email, password }).pipe(
      tap((response_data: any) => {
        this.isLoadingSubject.next(true);
        const actualResponse = response_data.response || response_data;
        if (actualResponse && actualResponse.access_token) {    
          localStorage.setItem(this.tokenKey, actualResponse.access_token); 
          const user = actualResponse.user as User;
          this.saveUser(user);
          this.currentUserValue = user; 
          this.isLoggedIn = true;
          console.log("User and Token Stored:", user, actualResponse.access_token);
          this.router.navigate(['/dashboard']);
        }
      }),
      catchError(this.handleError)
    );
  }

  logout() {
    const token = localStorage.getItem(this.tokenKey);
  
    if (!token) {
      console.error('No token found in local storage');
      return;
    }
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    this.http.get(`${environment.apiUrl}/logout`, {headers}, ).subscribe({
      next: (response) => {
        console.log('Logout successful', response);
        localStorage.removeItem(this.tokenKey);
        localStorage.removeItem(this.userKey);
        this.currentUserValue = null;
        this.isLoggedIn = false;
        this.router.navigate(['/auth/login']);
      },
      error: (error) => {
        console.error('Logout failed', error);
      },
    }); 
  }
  

  private saveUser(user: User) {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  private getUser(): User | null {
    const userData = localStorage.getItem(this.userKey);
    return userData ? JSON.parse(userData) as User : null;
  } 

 handleError = (err: HttpErrorResponse) => {
  let errorMessage = 'Unknown error occurred';

  if (err.status === 401) {
    errorMessage = 'Unauthorized access. Please log in again.';
    this.logout();  
  } else if (err.error && typeof err.error === 'string') {
    errorMessage = err.error;
  } else if (err.error && err.error.response?.message) {
    errorMessage = err.error.response.message;
  }

  console.error('Error:', err);
  return throwError(() => new Error(errorMessage));
}

  getUserInfo(): Observable<any> {
    const token = localStorage.getItem(this.tokenKey);
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.get<any>(`${environment.apiUrl}/userinfo`, { headers });
  }
}
